<template>
  <div class="tech-jumbotron flex-1">
    <div class="flex items-center flex-col">
      <div class="tech-jumbotron-info">
        Hi, you are currently not a fit for what we're looking for.
        But I'm sure there are other fits out there for you!
        Feel free to apply again in 6 month if something changes with your resume or your certifications.
      </div>
      <div class="tech-jumbotron-img">
        <img src="@/assets/image/consultant_refuse.png" alt="refuse" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted: function() {
    this.$store.commit("closeSidebar");
  }
};
</script>